import { render } from "./DownloadProfile.vue?vue&type=template&id=51a4cc4a"
import script from "./DownloadProfile.vue?vue&type=script&lang=js"
export * from "./DownloadProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__